// Mock data for MeraPMRahul.com

export const mockData = {
  // Live counter
  pledgeCount: 5342,

  // Stories from supporters
  stories: [
    {
      id: 1,
      name: "Ramesh Kumar",
      location: "Amethi, Uttar Pradesh",
      occupation: "Farmer",
      image: "https://images.unsplash.com/photo-1749793299204-462f634e53cc",
      quote: "वो हमारी सुनते हैं, हमारे बीच चलते हैं। मेरा PM राहुल।",
      videoUrl: null
    },
    {
      id: 2,
      name: "Priya Sharma",
      location: "Delhi",
      occupation: "Teacher",
      image: "https://images.unsplash.com/photo-1677475455591-f694f2e0848a",
      quote: "Truth and justice - that's what India needs. #MeraPMRahul",
      videoUrl: null
    },
    {
      id: 3,
      name: "Arjun Singh",
      location: "Mumbai, Maharashtra",
      occupation: "Youth Leader",
      image: "https://images.unsplash.com/photo-1703192103626-1433302256e5",
      quote: "नफरत नहीं, प्यार की राजनीति। राहुल गांधी का भारत।",
      videoUrl: null
    },
    {
      id: 4,
      name: "Sunita Devi",
      location: "Patna, Bihar",
      occupation: "Small Business Owner",
      image: "https://images.unsplash.com/flagged/photo-1579503429289-6de86c9fc2de",
      quote: "He walks with us, fights for us. Mera PM Rahul.",
      videoUrl: null
    },
    {
      id: 5,
      name: "Vikram Patel",
      location: "Ahmedabad, Gujarat",
      occupation: "Student",
      image: "https://images.unsplash.com/photo-1723056416893-e38cdbd35685",
      quote: "युवाओं की उम्मीद, राहुल गांधी। #MeraPMRahul",
      videoUrl: null
    },
    {
      id: 6,
      name: "Anita Desai",
      location: "Bengaluru, Karnataka",
      occupation: "IT Professional",
      image: "https://images.unsplash.com/photo-1723056416947-4ca0f01c229a",
      quote: "Leadership with compassion is what India deserves.",
      videoUrl: null
    }
  ],

  // Upcoming events
  events: [
    {
      id: 1,
      title: "Nyay Yatra - Delhi Rally",
      date: "2025-09-15",
      time: "10:00 AM",
      location: "Ramlila Maidan, Delhi",
      state: "Delhi",
      description: "Join us for a massive rally supporting truth and justice.",
      rsvpCount: 15430
    },
    {
      id: 2,
      title: "Youth Congress Meet",
      date: "2025-09-20",
      time: "3:00 PM",
      location: "Mumbai University Campus",
      state: "Maharashtra",
      description: "Campus leaders and youth discussion forum.",
      rsvpCount: 890
    },
    {
      id: 3,
      title: "Kisan Sammelan",
      date: "2025-09-25",
      time: "11:00 AM",
      location: "Lucknow, UP",
      state: "Uttar Pradesh",
      description: "Farmers' gathering to discuss agricultural policies.",
      rsvpCount: 5200
    },
    {
      id: 4,
      title: "Booth Workers Training",
      date: "2025-09-28",
      time: "9:00 AM",
      location: "AICC Headquarters, Delhi",
      state: "Delhi",
      description: "Training session for grassroots organizers.",
      rsvpCount: 320
    }
  ],

  // Pledge wall entries
  pledges: [
    {
      id: 1,
      name: "Rajesh M.",
      state: "Karnataka",
      message: "I believe in truth and justice. I believe in Rahul Gandhi's India. #MeraPMRahul",
      timestamp: "2025-08-20T10:30:00Z"
    },
    {
      id: 2,
      name: "Meena S.",
      state: "Rajasthan",
      message: "सच्चाई और न्याय के लिए। राहुल गांधी के भारत के लिए। #MeraPMRahul",
      timestamp: "2025-08-20T11:15:00Z"
    },
    {
      id: 3,
      name: "Amit K.",
      state: "Uttar Pradesh",
      message: "Unity over hatred. Compassion over division. #MeraPMRahul",
      timestamp: "2025-08-20T12:00:00Z"
    },
    {
      id: 4,
      name: "Kavita D.",
      state: "Maharashtra",
      message: "मेरा प्रधानमंत्री, मेरा विश्वास - राहुल गांधी। #MeraPMRahul",
      timestamp: "2025-08-20T13:20:00Z"
    }
  ],

  // State-wise pledge distribution for map
  stateData: [
    { state: "Uttar Pradesh", pledges: 185234 },
    { state: "Maharashtra", pledges: 142567 },
    { state: "Bihar", pledges: 98432 },
    { state: "West Bengal", pledges: 87654 },
    { state: "Karnataka", pledges: 76543 },
    { state: "Tamil Nadu", pledges: 65432 },
    { state: "Rajasthan", pledges: 54321 },
    { state: "Gujarat", pledges: 48765 },
    { state: "Madhya Pradesh", pledges: 45678 },
    { state: "Delhi", pledges: 39876 },
    { state: "Punjab", pledges: 34567 },
    { state: "Haryana", pledges: 28765 },
    { state: "Kerala", pledges: 25432 },
    { state: "Odisha", pledges: 23456 },
    { state: "Telangana", pledges: 21234 }
  ],

  // Social media feed
  socialFeed: [
    {
      id: 1,
      platform: "twitter",
      username: "@supporter1",
      content: "Walked 5km today in Bharat Jodo spirit. Every step for truth! #MeraPMRahul",
      likes: 234,
      timestamp: "2h ago"
    },
    {
      id: 2,
      platform: "instagram",
      username: "@youth_leader_mumbai",
      content: "Campus meet was amazing! 500+ students joined. #MeraPMRahul",
      likes: 567,
      timestamp: "4h ago"
    },
    {
      id: 3,
      platform: "twitter",
      username: "@farmer_voice",
      content: "किसानों का साथी, मज़दूरों का नेता। #MeraPMRahul",
      likes: 892,
      timestamp: "6h ago"
    }
  ],

  // Media resources
  mediaResources: [
    {
      id: 1,
      title: "Bharat Jodo Yatra Highlights",
      type: "video",
      description: "4,000 km journey of unity and hope.",
      downloadUrl: "#"
    },
    {
      id: 2,
      title: "Campaign Poster Pack (Hindi)",
      type: "graphics",
      description: "Social media ready posters and banners.",
      downloadUrl: "#"
    },
    {
      id: 3,
      title: "Recent Speeches Collection",
      type: "audio",
      description: "Key speeches on justice, unity, and progress.",
      downloadUrl: "#"
    },
    {
      id: 4,
      title: "Press Release Archive",
      type: "document",
      description: "Official statements and press releases.",
      downloadUrl: "#"
    }
  ],

  // Volunteer data
  volunteerStats: {
    totalVolunteers: 45678,
    activeBooths: 12345,
    campusAmbassadors: 890,
    eventsOrganized: 234
  }
};
